module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "ats"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("BOUT")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HIS")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERIES")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text body-text-override"
  }, [_c('span', {
    staticClass: "no-style-override-18"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("W")]), _vm._v("elcome to the SCOPE of Leadership book series. The six books in this series are designed to build your knowledge of the thirty-eight competencies of great leaders who lead as coaches. These books provide the insights and principles great leaders as coaches use t")]), _c('span', {
    staticClass: "no-style-override-18"
  }, [_vm._v("o practice great leadership—the ability to achieve a desired result ")]), _c('span', {
    staticClass: "no-style-override-18"
  }, [_vm._v("through the influence of people who follow and perform by choice.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("By reading the SCOPE of Leadership book series, you will learn "), _c('span', {
    staticClass: "no-style-override-18"
  }, [_vm._v("how to set the example you expect others to follow. You will learn how to coach and develop others, build trust and high-performance ")]), _vm._v("teams, and foster collaboration and innovation. You will understand "), _c('span', {
    staticClass: "no-style-override-18"
  }, [_vm._v("what it takes to motivate and inspire others and discover how to impart ownership and stimulate engagement. You will learn how to ")]), _vm._v("develop engaging presentations and speak with confidence. You will understand how to craft win-win partnerships and manage conflict. Most importantly, you will learn how to shape organizational culture, operate with excellence, and deliver exceptional results.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The SCOPE of Leadership is for anyone who aspires to be a great leader. It is for business professionals who want to advance in their career as well as community leaders who want to make a positive impact on society. It is for parents and grandparents who want to be better examples to their children and raise them to be great leaders. It is for athletic coaches who want to help athletes become their best. It is for teachers, principals, church leaders, and others in positions of influence who aspire to influence people positively in order to reach a desired result.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d34f08c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/04-ats.vue
// module id = 69
// module chunks = 0